import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo(this.pageNo);
        this.GetAllPaymentMethods();
        this.GetAllFinancialsWithdrawing();
    },


    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },

        totalPagesT() {
            return Math.ceil(this.pagesT / this.pageSizeT);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            pageNoT: 1,
            pageSizeT: 10,
            pagesT: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  المستخدمين ',
            ScreenTitleSingle: '  مستخدم   ',
            ScreenTitleSingleAl: ' المستخدم  ',

            Info: [],
            InfoT: [],
            Statistics: [],

            InfoFinancialsTracker: [],

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
                UserType: '',
            },
            rules: {
                Name: this.$helper.Required(),
                UserType: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                Email: this.$helper.EmailOnly(),
            },

            FinancialsruleForm: {
                Id: '',
                PaymentMethodsId: '',
                WithdrawingId: '',
                OperationOn: '',
                Value: '',
                Descriptions: '',
            },
            Financialsrules: {
                PaymentMethodsId: this.$helper.Required(),
                WithdrawingId: this.$helper.Required(),
                OperationOn: this.$helper.Required(),
                Value: this.$helper.Required(),
                Descriptions: this.$helper.Required(),
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetUsers(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },


        submitForm() {

            const form = document.getElementById('userForm');

            // 2. Check native Bootstrap validation
            if (!form.checkValidity()) {
                // Show validation colors
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');
            this.ruleForm.Id = Number(0);

            this.$blockUI.Start();
            this.$http.AddUsers(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('Close'); // Close modal
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
            this.GetUsersTransactionsInfo();
            this.state = 1;
        },

        GetUsersTransactionsInfo(pageNoT) {
            this.pageNoT = pageNoT;
            if (this.pageNoT === undefined) {
                this.pageNoT = 1;
            }

            this.$blockUI.Start();

            this.$http.GetUsersTransactions(this.pageNoT, this.pageSizeT, this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.$blockUI.Stop();
                    this.InfoT = response.data.info;
                    this.pagesT = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pagesT = 0;
                });
        },


        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;

        },

        submitEditForm() {
            // 1. Reference the form element (the same ID used in your HTML)
            const form = document.getElementById('userForm');

            // 2. Smart Validation: Check native Bootstrap validity
            // And verify against your custom rules from Helper.js
            if (!form.checkValidity()) {
                // Show validation colors
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            // 3. Form is valid: Reset UI state and prepare data
            form.classList.remove('was-validated');
            // Convert Id to Number to match backend 'long' expectation
            this.ruleForm.Id = Number(this.ruleForm.Id);

            // 4. Call the Edit API
            this.$blockUI.Start();
            this.$http.EditUsers(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo); // Refresh the table
                    this.ClearForm(this.ruleForm); // Reset form data
                    this.$helper.DestroyElemntById('Close'); // Close the modal
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    // Handle error messages returned by the UserController
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', errorMsg);
                });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        ResetPassword(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تهيئة كلمة المرور   ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ResetPasswordUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },






        //Financials
        OpenFinancials(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
        },

        submitFinancialsruleForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.FinancialsruleForm.Id = this.SelectedItem.id;
                    this.FinancialsruleForm.Value = Number(this.FinancialsruleForm.Value);
                    this.$blockUI.Start();
                    this.$http.PayUsersFinancials(this.FinancialsruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.GetFinancialsTracker();
                            this.ClearForm(this.FinancialsruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpenFinancialsTracker(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
            this.GetFinancialsTracker();

        },

        GetFinancialsTracker() {
            this.$blockUI.Start();
            this.$http.GetUsersFinancials(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InfoFinancialsTracker = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        DeleteFinancials(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsersFinancials(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                            this.GetFinancialsTracker();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },





        Back() {
            this.SelectedItem = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

    }
}
